<template>
  <div class="edit-form">
    <a-form-model :layout="layout" :model="formState">
      <a-form-model-item label="字段1：">
        {{ formState.field1 }}
      </a-form-model-item>
      <a-form-model-item label="字段2：">
        {{ formState.field2 }}
      </a-form-model-item>
      <a-form-model-item label="字段3：">
        {{ formState.field3 }}
      </a-form-model-item>
      <a-form-model-item label="字段4：">
        {{ formState.field4 }}
      </a-form-model-item>
      <a-form-model-item label="字段5：">
        {{ formState.field5 }}
      </a-form-model-item>
      <a-form-model-item label="字段6：">
        {{ formState.field6 }}
      </a-form-model-item>
      <a-form-model-item label="字段7：">
        {{ formState.field7 }}
      </a-form-model-item>
      <a-form-model-item label="字段8：">
        {{ formState.field8 }}
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    layout: {
      type: String,
      default: 'inline',
    },
  },
  data() {
    return {
      formState: {
        field1: '字段1',
        field2: '字段2',
        field3: '字段3',
        field4: '字段4',
        field5: '字段5',
        field6: '字段6',
        field7: '字段7',
        field8: '字段8',
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化数据
    init() {
      let params = { results: 10, page: 1 };
      axios.get('https://randomuser.me/api', { params: params }).then(({ data }) => {
        this.formState = {
          field1: '字段1',
          field2: '字段2',
          field3: '字段3',
          field4: '字段4',
          field5: '字段5',
          field6: '字段6',
          field7: '字段7',
          field8: '字段8',
        };
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .ant-form-inline {
  .ant-form-item {
    width: calc(50% - 16px);
  }
}
</style>
